import { render } from "./CustomLoginbackground.vue?vue&type=template&id=67a3f543&scoped=true&ts=true"
import script from "./CustomLoginbackground.vue?vue&type=script&lang=ts"
export * from "./CustomLoginbackground.vue?vue&type=script&lang=ts"

import "./CustomLoginbackground.vue?vue&type=style&index=0&id=67a3f543&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a3f543"]])

export default __exports__